import React from "react";
import ErrorScreen from "./ErrorScreen";

/**
 * Root error boundary — the app's last line of defense.
 *
 * Without a boundary, ANY uncaught render/lifecycle error makes React
 * unmount the entire tree: the screen freezes on (or blanks to) whatever
 * was last painted while the URL keeps changing — indistinguishable from a
 * hang, and the only way out is a hard refresh. With this boundary the user
 * gets the standard crash screen and a one-click reload that returns to the
 * SAME URL (routes are URL-driven, so reload restores their place).
 *
 * The error + component stack go to console.error so a DevTools screenshot
 * from the field pinpoints the crash site.
 */
export default class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { crashed: false };
  }

  static getDerivedStateFromError() {
    return { crashed: true };
  }

  componentDidCatch(error, info) {
    console.error("[RootErrorBoundary] app crashed:", error, info?.componentStack);
  }

  render() {
    if (!this.state.crashed) return this.props.children;
    return (
      <ErrorScreen
        code="crash"
        primary={{ label: "Reload this page", onClick: () => window.location.reload() }}
        secondary={{ label: "Go to dashboard", onClick: () => { window.location.href = "/app/dashboard"; } }}
      />
    );
  }
}
